export default __webpack_public_path__ + "static/android-chrome-192x192-4fdabd973f446fd12654eded44873469.png";